module.exports = "mutation ($data: LeadCreate!) {\n  LeadCreate(data: $data) {\n    id\n  }\n}"